import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import ActivityConfigStore from '@src/pages/shared/activity-config-store';

class CourseStore extends ActivityConfigStore {
  moreBenefitsSwiper = new BaseSwiperStore({
    swiperOptions: {
      autoplay: {
        delay: 4000,
        disableOnInteraction: false
      },
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    }
  });
}

export default CourseStore;
